import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/functions';
//import store from './../store';
//import router from './../router';

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
};
firebase.initializeApp(firebaseConfig);

// utils
const db = firebase.firestore();
const auth = firebase.auth();
const fnc = firebase.functions();

firebase.getCurrentUser = () => {
  return new Promise((resolve, reject) => {
      const unsubscribe = auth.onAuthStateChanged(user => {
          unsubscribe();
          resolve(user);
      }, reject);
  })
};

auth.onAuthStateChanged(user => {
  if (user) {
    // User is signed in.
   /*  console.log('USER DATA CHANGED ------');
    console.log(user);
    console.log('------------------------');
    if (user.emailVerified) {
      console.log('user.emailVerified: ' + user.emailVerified);
      store.dispatch('autoSignIn', user);
      router.push({ path: '/' });
    } else {
      console.log('user.emailVerified: ' + user.emailVerified);
      user.sendEmailVerification();
      router.push({ path: '/email-verify' });
    } */
  } else {
    // No user is signed in.
  }
  //store.dispatch("fetchUser", user);
});

// collection references
const procesosCollection = db.collection('procesos');

// export utils/refs
export { firebase, db, auth, fnc, procesosCollection };
